<script>
import { routeIsSettings } from '@/helpers/routes'
import LOGIN_TO_PATIENT from '@/plugins/http/patient'
import REGISTER_TO_PATIENT from '@/plugins/http/patient-register'

export default {
  name: 'top-menu-professional',
  data () {
    return {
      LOGIN_TO_PATIENT: LOGIN_TO_PATIENT,
      REGISTER_TO_PATIENT: REGISTER_TO_PATIENT
    }
  },
  computed: {
    routeIsSettings () {
      return routeIsSettings(this.$route)
    }
  },
  methods: {
    goToLoginPatient () {
      location.href = this.LOGIN_TO_PATIENT
    },
    goToRegisterPatient () {
      location.href = this.REGISTER_TO_PATIENT
    }
  }
}
</script>

<template lang="pug">
  div
      #switch-page.container-fluid.switch-page-professional
        .container
          router-link.pull-right.transition(:to="{ name: 'professional.loading-page.index'}")
           strong(style="color: #fff")  Acesse a Área do Profissional de Saúde
      #menu-wrapper.container-fluid
        .container
          #logo.col-sm-3.col-md-2
            a(href="/patient/loading-page/index")
             img(src='/static/images/logo.svg', width='164', height='50')
          ul#menu.col-sm-8.col-md-10
            a(href='', v-scroll-to="'#apresentacao'")
              li.apresentacao Apresentação
            a(href='', v-scroll-to="'#beneficios'")
              li.beneficios Benefícios
            a(href='', v-scroll-to="'#contato'")
              li.contato Contato
            a#login.pull-right.m-left-5.hidden-xs.hidden-md.hidden-sm(@click.prevent="goToRegisterPatient()")
              | Cadastro
              span.icon 
            a#login.pull-right(@click.prevent="goToLoginPatient()")
              | Entrar
              span.icon 
</template>
<style scoped>
  /* Switch */
#menu-wrapper #login {
    color: #ffffff;
    background: #0c6bb5;
    border-radius: 50px;
    padding: 5px 15px 5px 25px;
    font-size: 16px;
    margin: 30px 3px;
    font-weight: 300;
    -webkit-transition: color ease .3s, padding ease .3s;
    transition: color ease .3s, padding ease .3s;
    cursor: pointer;
}
#switch-page {
    background: #e01111;
    overflow: hidden;
}

#switch-page a {
    color: #fff;
    font-size: 13px;
    font-weight: 300;
    padding: 3px 0px;
    margin: 5px 0px;
    position: relative;
    border-bottom: 1px solid #fff;
    text-decoration: none;
    -webkit-transition: border ease .3s;
    transition: border ease .3s;
}

#switch-page a:hover {
    border-bottom: 1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/layout/headers/topMenuPatient.vue